/* eslint-disable */
import { PaginationControl } from "react-bootstrap-pagination-control";
import React, { useState } from "react";
// import ExpenseDialog from "../views/ExpenseDialog";
import { useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import SideBar from "../../SideBar";
import { FaCashRegister, FaFileMedical, FaFileExcel, FaRegEdit, FaRegTrashAlt, FaSave } from 'react-icons/fa'
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import Swal from "sweetalert2";
import SearchIcon from '../../../../assets/img/Search.gif'
import apiInstance from "../../../../utils/api";

const LabServiceList = () => {
    const [open, setOpen] = useState(false);
    const [reagentItemList, setReagentItemList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [showLoading, setShowLoading] = useState(false);
    const [id, setId] = useState('');
    const [testName, setTestName] = useState('');
    const [page, setPage] = useState(1);
    const [pages, setPages] = React.useState("");
    const [dataCount, setDataCount] = useState("");
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const paginationItems = React.useMemo(() => {
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        return filteredList?.slice(start, end);
    }, [page, filteredList]);
    // console.log(paginationItems, 'pag')

    const search = async () => {

        const data = {
            startDate: from,
            endDate: to
        }
        await apiInstance.post(
            'reagent-item/filter', data
        ).then((res) => {
            console.log(res.data.data, 'res')

            setFilteredList(
                res.data.data
            )

        }).catch((err) => {
            Swal.fire({
                title: 'Something Wrong!',
                text: 'No Record Found',
                icon: 'warning',
                // showCancelButton: true,

                cancelButtonText: 'Close'
            })
            console.log(err.message)
        })

    }

    const handleInputChange = (event) => {
        // console.log(labServiceLists, 'name')
        const searchValue = event.target.value.toLowerCase()
        event.target.value.toLowerCase()
        const searchData = reagentItemList.filter(test => test.itemName.toLowerCase().includes(searchValue) || test.code.toLowerCase().includes(searchValue) || test.relatedCategory?.name.toLowerCase().includes(searchValue))
        setFilteredList(searchData)
        setDataCount(
            searchData.length
        );
        setPages(
            searchData.length %
                rowsPerPage ===
                0
                ? searchData.length /
                rowsPerPage
                : Math.floor(
                    searchData.length /
                    rowsPerPage
                ) + 1
        );
    }

    const handleUpdate = (reg) => {
        const data = {
            id: reg._id,
            name: reg.name,
            code: reg.code,
            itemName: reg.itemName,
            currentQuantity: reg.currentQuantity,
            reOrderQuantity: reg.reOrderQuantity,
            purchasePrice: reg.purchasePrice,
            // sellingPrice: upSell,
            fromUnit: reg.fromUnit,
            toUnit: reg?.toUnit,
            totalUnit: reg?.totalUnit,
            purposeType: reg.purposeType,
            // itemType: type,
            description: reg.description,
        };

        const config = {
            headers: { "Content-Type": "application/json" },
        };
        apiInstance.put("reagent-item", data, config).then(function (response) {
            Swal.fire({
                title: "Successful!",
                text: "You Updated Data!",
                icon: "success",
                showConfirmButton: false,
                timer: 2000
            });
            // window.location.reload();

            // return response.data.data

            setFilteredList(
                filteredList.map(item => {
                    if (item._id === response.data.data._id) {
                        return response.data.data
                    } else {
                        return item
                    }
                })
            )
        })

            .catch((error) => {
                Swal.fire({
                    title: "Error",
                    text: error,
                    icon: "error",
                    confirmButtonText: "CANCEL",
                });
            });
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                apiInstance.delete("reagent-item/" + id)
                    .then((response) => {
                        Swal.fire({
                            title: "Success",
                            text: "Successfully Deleted!",
                            icon: "success",
                            showConfirmButton: false,
                            timer: 2000
                        });
                        setFilteredList(filteredList.filter(item => item._id !== id));
                        setReagentItemList(reagentItemList.filter(item => item._id !== id));
                        setDataCount(dataCount - 1);
                    })
                    .catch((error) => {
                        Swal.fire({
                            title: "Error",
                            text: error.response?.data?.message || error.message,
                            icon: "error",
                            confirmButtonText: "CANCEL",
                        });
                    });
            }
        });
    };

    const handleCalculate = (val, type, regItem) => {
        if (type === 'currentQuantity') {
            const total = (val * parseInt(regItem?.toUnit))

            // console.log(total, 'total')
            const newData = paginationItems.map((data) => {
                if (data._id === regItem._id) {
                    return { ...data, [type]: parseInt(val), totalUnit: total };
                }
                return data;
            });
            // console.log(newData);
            setFilteredList(newData);

        } else if (type === 'toUnit') {
            const total = (parseInt(regItem?.currentQuantity) * val)
            // console.log(total, 'total')
            const newData = paginationItems.map((data) => {
                if (data._id === regItem._id) {
                    return { ...data, [type]: parseInt(val), totalUnit: total };
                }
                return data;
            });
            // console.log(newData);
            setFilteredList(newData)
        }

    };



    const showDialog = () => setOpen(true);
    const _export = React.useRef(null);
    const excelExport = () => {
        if (_export.current !== null) {
            console.log(_export.current.props.data);
            _export.current.props.data.map(function (element, index) {
                element.expDate = element.expDate?.split('T')[0]
                element.supplier = element.relatedSupplier?.name
            });
            _export.current.save();
        }
    };
    useEffect(() => {
        const getReagentItemList = async () => {
            const res = await apiInstance.get(
                "reagent-item"
            );

            setReagentItemList(res.data.list);
            setFilteredList(res.data.list);
            setDataCount(
                res.data.list.length
            );
            setPages(
                res.data.list.length %
                    rowsPerPage ===
                    0
                    ? res.data.list.length /
                    rowsPerPage
                    : Math.floor(
                        res.data.list.length /
                        rowsPerPage
                    ) + 1
            );
        };
        getReagentItemList();
    }, []);
    return (
        <div classNameName="App">
            {/* <!-- end preloader --> */}
            {/* @include('sweet::alert') */}

            <div className="wrapper">
                <SideBar />
                {/* <!-- Content Wrapper. Contains page content --> */}

                <div className="content-wrapper">
                    {/* <!-- Content Header (Page header) --> */}
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a href="/lab-test">Home</a>
                                        </li>
                                        <li className="breadcrumb-item active">Stock Count List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Main content --> */}

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    {/* <div className="row">
                    <div className="form-group col-md-5">
                      <label>From</label>
                      <input
                        type="date"
                        name="from"
                        id="from"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-5">
                      <label>To</label>
                      <input
                        type="date"
                        name="to"
                        id="to"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-2">
                      <button
                        className="btn btn-sm btn-primary form-control"
                        style={{ marginTop: "32px" }}
                        onclick="date_filter()">
                        Search
                      </button>
                    </div>
                  </div> */}
                                </div>

                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <div class="row justify-content-between py-3">
                                                <div className='col-5'>
                                                    <div className='row'>
                                                        <div className='col-4'>
                                                            <label htmlFor=''>From:</label>
                                                            <input
                                                                type='date'
                                                                placeholder='Search...'
                                                                className='form-control'
                                                                onChange={e => setFrom(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='col-4'>
                                                            <label htmlFor=''>To:</label>
                                                            <input
                                                                type='date'
                                                                placeholder='Search...'
                                                                className='form-control'
                                                                onChange={e => setTo(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='col-4' style={{ marginTop: '30px' }}>
                                                            <button
                                                                className='btn btn-md border-1 border-dark rounded-3'

                                                                onClick={search}
                                                            >
                                                                Search
                                                                &nbsp;
                                                                {/* {(showLoading) && (
                                                                    <img src={SearchIcon} width='30px' />
                                                                )} */}

                                                            </button>
                                                            {/* <button className='btn btn-sm btn-primary ml-3'>Export</button> */}

                                                        </div>
                                                    </div>
                                                </div>



                                                <div className="input-group float-right col-4" style={{ marginTop: '30px' }}>
                                                    <input
                                                        type="search"
                                                        className="form-control rounded"
                                                        id="search_code"
                                                        placeholder="Search ..."
                                                        onChange={event =>
                                                            handleInputChange(
                                                                event
                                                            )
                                                        }
                                                    />
                                                    &nbsp;


                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-success rounded-2"
                                                        onClick={excelExport}>
                                                        <FaFileExcel
                                                        />&nbsp;Export
                                                    </button>
                                                </div>



                                            </div>
                                            <div className=' row font-weight-bold text-lg'>Total {filteredList?.length} List</div>
                                        </div>

                                        <div class="card-body">
                                            {/* Export data in Excel */}
                                            <ExcelExport data={filteredList} ref={_export}>
                                                <ExcelExportColumn
                                                    field=""
                                                    title="No"
                                                    locked={true}
                                                    width={30}
                                                />
                                                <ExcelExportColumn
                                                    field="expDate"
                                                    title="Expired"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={150}
                                                />
                                                <ExcelExportColumn
                                                    field="code"
                                                    title="Code"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={200}
                                                />

                                                <ExcelExportColumn
                                                    field="itemName"
                                                    title="Reagent Name"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={250}
                                                />

                                                <ExcelExportColumn
                                                    field="currentQuantity"
                                                    title="Current Quantity"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={250}
                                                />

                                                <ExcelExportColumn
                                                    field="fromUnit"
                                                    title="From Unit"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={150}
                                                />
                                                <ExcelExportColumn
                                                    field="toUnit"
                                                    title="To Unit"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={150}
                                                />
                                                <ExcelExportColumn
                                                    field="totalUnit"
                                                    title="Total Unit"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={150}
                                                />
                                                <ExcelExportColumn
                                                    field="unit"
                                                    title="Unit"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={150}
                                                />
                                                <ExcelExportColumn
                                                    field="supplier"
                                                    title="Supplier"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={150}
                                                />
                                                <ExcelExportColumn
                                                    field="device"
                                                    title="Device"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={150}
                                                />
                                                <ExcelExportColumn
                                                    field="purposeType"
                                                    title="Purpose Type"
                                                    headerCellOptions={{
                                                        textAlign: "center",
                                                    }}
                                                    width={150}
                                                />

                                            </ExcelExport>
                                            {/* Export Data in Excel end */}
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div
                                                        class="table-responsive text-black d-flex overflow-auto" style={{ whiteSpace: 'nowrap' }}
                                                        id="slimtest2">
                                                        <table class="table table-hover" id="filter_date">
                                                            <thead className="headtable text-white">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Expired Date</th>
                                                                    <th>Code</th>
                                                                    {/* <th>Bank / Cash Account</th>  */}
                                                                    <th>Name</th>

                                                                    <th>Current Qty</th>

                                                                    <th>From Unit</th>
                                                                    <th>To Unit</th>
                                                                    <th>Total Unit</th>
                                                                    <th>Unit</th>
                                                                    <th>Supplier</th>
                                                                    <th>Device</th>
                                                                    <th>Purpose Type</th>
                                                                    {/* <th className="text-center">Multi Test</th> */}
                                                                    <th className="text-center">Action</th>
                                                                </tr>
                                                            </thead>

                                                            {paginationItems[0] ? paginationItems.map((labService, i) => (
                                                                <tbody className="">
                                                                    <tr>
                                                                        <td>{(page - 1) * rowsPerPage + i + 1}</td>
                                                                        <td>
                                                                            {labService?.expDate?.split('T')[0]}
                                                                        </td>
                                                                        <td>
                                                                            {labService.code ? labService.code : ""}
                                                                        </td>

                                                                        <td>
                                                                            {labService.itemName ? labService.itemName : ""}
                                                                        </td>

                                                                        <td>
                                                                            <input type='number' value={labService?.currentQuantity} className='form-control' onChange={(e) => handleCalculate(e.target.value, 'currentQuantity', labService)} />
                                                                        </td>

                                                                        <td>
                                                                            <input type='number' value={labService?.fromUnit} disabled className='form-control' />
                                                                        </td>

                                                                        <td>
                                                                            <input type='number' value={labService?.toUnit} className='form-control' onChange={(e) => handleCalculate(e.target.value, 'toUnit', labService)} />
                                                                        </td>
                                                                        <td>
                                                                            <input type='number' value={labService?.totalUnit} disabled className='form-control' />
                                                                        </td>
                                                                        <td>
                                                                            {labService?.unit
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {labService?.relatedSupplier?.name}
                                                                        </td>
                                                                        <td>
                                                                            {labService?.device}
                                                                        </td>
                                                                        <td>
                                                                            {labService?.purposeType
                                                                            }
                                                                        </td>
                                                                        {/* <td className="text-center">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-primary ml-2"
                                        onClick={() =>
                                          handleCheckChange(
                                            labService.subTest._id
                                          )
                                        }>
                                        Check
                                      </button>
                                    </td> */}
                                                                        <td className='d-flex justify-content-between'>

                                                                            <button
                                                                                onClick={() => handleUpdate(labService)}
                                                                                className="btn btn-md text-black bg-blue"
                                                                                role="button">
                                                                                <FaSave />
                                                                                {/* <FaRegEdit /> */}
                                                                            </button>

                                                                            &nbsp;
                                                                            <button
                                                                                className="btn btn-sm btn-danger text-white"

                                                                                onClick={(e) =>
                                                                                    handleDelete(labService._id)
                                                                                }>
                                                                                <FaRegTrashAlt />
                                                                            </button>
                                                                        </td>
                                                                    </tr>


                                                                </tbody>
                                                            )) : (
                                                                <div className='py-3 d-flex justify-content-center'>

                                                                    {/* <img src={SearchIcon} width='70px' /> */}
                                                                    <span className='text-md'>Loading . . .</span>

                                                                </div>
                                                            )}
                                                        </table>
                                                    </div>
                                                    <div className='mt-4'>
                                                        <PaginationControl
                                                            page={page}
                                                            between={4}
                                                            total={dataCount}
                                                            limit={50}
                                                            changePage={(page) => {
                                                                setPage(page);
                                                            }}
                                                            ellipsis={1}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <ExpenseDialog
                open={open}
                close={() => setOpen(false)}
                expenseLists={expenseLists}
                setExpenseLists={setExpenseLists}
              /> */}
                            {/* <LabServiceUpdate
                open={updateDialog}
                close={() => setUpdateDialog(false)}
                labid={id}
                setUpdateDialog={setUpdateDialog}
               
                setLabServiceLists={setLabServiceLists}
                labServiceLists={labServiceLists}
              /> */}
                        </div>
                        {/*<!-- /.container-fluid --> */}
                    </section>
                </div>
            </div >

            {/* <!-- /.content-wrapper --> */}
            < footer className="main-footer" >
                <strong>
                    Copyright &copy; 2017-2020{" "}
                    <a href="http://www.kwintechnologies.com">K-win Technology</a>.
                </strong>
                All rights reserved.
            </footer >

            {/* <!-- Control Sidebar --> */}
            < aside classNameName="control-sidebar control-sidebar-dark" >
                {/* <!-- Control sidebar content goes here --> */}
            </aside >
            {/* <!-- /.control-sidebar --> */}

            {/* <!-- ./wrapper --> */}
        </div >
    );
};
export default LabServiceList;
